module.exports = __webpack_public_path__ + "img/img_pc.90b4179f.jpg";